import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from '../../auth';
import { Cookie } from 'ng2-cookies';
import { Environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';

@Injectable()
export class NewRegisterFormService implements OnInit {

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    ngOnInit() : void {
        this.authService.isTokenValid();
    }

    /**
     * Save new RK
     * @param registerControl registerControl object    
     * @param useDigitalExport second attachment
     */
    saveRk(registerControl: any, useDigitalExport: boolean) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-registercontrol';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('registerBody', JSON.stringify(registerControl))           
            .set('useDigitalExport', JSON.stringify(useDigitalExport));

        return this.http.post(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Save new RK
     * @param registerControl registerControl object
     * @param useDigitalExport second attachment
     */
    updateRk(registerControl: any, useDigitalExport: boolean) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-registercontrol/' + registerControl.id;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('registerBody', JSON.stringify(registerControl))
            .set('useDigitalExport', JSON.stringify(useDigitalExport));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Get all addressCodes
     * @returns 
     */
     getAllAddressCodes() {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/addressCode';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Get a addressCode ID based on a name
     */
     deleteAddressCode(addressCodeId) {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/addressCode/delete/' + addressCodeId;

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }
    
    /**
     * Get a list of unique professions
     *
     */
     getAllUniqueProfessions() : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/profession';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
            //.set('Authorization', 'Bearer ' + Cookie.get(this.globals.clientId + '_accessToken'));


        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Get a profession ID based on a name
     */
     deleteProfession(professionId) {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/profession/delete/' + professionId;

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Delete a person investigation attachment from a specific rk
     * @param rkId 
     * @returns registercontrol object
     */
    deleteRkAttachment(rkId:string){
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-registercontrol/delete/rkAttachment/' + rkId;

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }
    
    /**
     * Update new receiver
     * @param receiver receiver object
     */
    updateReceiver(receiver) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/receiverPerson';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('receiverPersonBody', JSON.stringify(receiver));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Update new receiver
     * @param receiver receiver object
     */
    updateProfession(receiver) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/profession';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('professionBody', JSON.stringify(receiver));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }
    
    /**
     * Update new receiver
     * @param receiver receiver object
     */
    updateAddressCode(receiver) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/addressCode';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('addressCodeBody', JSON.stringify(receiver));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }
}
